import { Component, createContext, useContext } from "react";

import { RouteWatcher } from "@citrine/atoms/route-watcher";

export type ErrorState =
  | { error: false; errorInfo?: never }
  | {
      error: Error;
      errorInfo?: React.ErrorInfo;
    };

export const errorStateContext = createContext<ErrorState>({ error: false });
export const useErrorStateContext = () => useContext(errorStateContext);

interface IErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  onError?: (error: Error) => void;
}

export class ErrorBoundary extends Component<IErrorBoundaryProps, ErrorState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { error: false };
    this.resetError = this.resetError.bind(this);
  }

  resetError() {
    const errorState: ErrorState = { error: false };
    this.setState(errorState);
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.props.onError?.(error);
    const errorState = { error, errorInfo };
    this.setState(errorState);
  }

  render() {
    return this.state.error && this.props.fallback ? (
      <errorStateContext.Provider value={this.state}>
        {this.props.fallback}
        <RouteWatcher onRouteChange={this.resetError} />
      </errorStateContext.Provider>
    ) : (
      this.props.children
    );
  }
}
